var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgThunder(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 209,
    height: 270,
    viewBox: "0 0 209 270",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M106.415 268.964C102.235 267.91 99.3126 264.141 99.3329 259.83L99.7794 165.214L12.018 188.704C8.41186 189.67 4.57671 188.403 2.25421 185.481C-0.0682764 182.558 -0.435446 178.536 1.31945 175.241L91.746 5.4617C93.7726 1.65663 98.133 -0.275815 102.313 0.778468C106.493 1.83277 109.416 5.60199 109.395 9.91304L108.949 104.529L196.71 81.0387C200.316 80.0734 204.152 81.3397 206.474 84.2624C208.797 87.185 209.164 91.2071 207.409 94.502L116.982 264.281C114.956 268.086 110.595 270.019 106.415 268.964Z",
    fill: "#FF2828"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThunder);
export default __webpack_public_path__ + "static/media/thunder.4af17eccd529701b65baed5f98b8b14e.svg";
export { ForwardRef as ReactComponent };